import React from "react";
import { useTranslation } from "react-i18next";
import { Wizard } from "@evergis/ui";

import { WizardWrapper } from "../../CopyResource/components/Layer/styled";
import { useImportContext } from "../importContext";
import { KMLImportStep } from "../types";

export const KMLImportWizard = () => {
  const { t } = useTranslation("dialogs");
  const { step } = useImportContext();

  return (
    <WizardWrapper>
      <Wizard
        currentStep={step - 1}
        steps={[
          {
            label: t("import.selectObjects"),
            disabled: step > KMLImportStep.Objects,
          },
          {
            label: t("import.setupAttributes"),
            disabled: step > KMLImportStep.Attributes,
          },
          {
            label: t("import.nameTheLayer"),
            disabled: step > KMLImportStep.Meta,
          },
          {
            label: t("import.complete"),
          },
        ]}
      />
    </WizardWrapper>
  );
};
